import React from 'react';

import ICO_HEART_2 from 'assets/images/xFrequentlyheart.svg';

const FrequentlyButton = (props) => (
  <button
    className="more-option-item"
    onClick={props.onClickFrequentBtn}
    role="menuitem"
    tabIndex={0}
    id="frequently-booked-btn"
  >
    <img
      src={ICO_HEART_2}
      style={{ width: '20px', height: '46px' }}
      alt="Frequently booked services"
      className="icon"
    />
    <div>Frequently Booked</div>
  </button>
);

export default FrequentlyButton;
